"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function List(_a) {
    var className = _a.className, children = _a.children, type = _a.type;
    return react_1.default.createElement("dl", { className: storybook_1.Helpers.classNames("storybook-lists-list-" + type, className || '') }, children);
}
exports.default = List;
;
List.propTypes = {
    /**
     * Add more classnames
     */
    className: prop_types_1.default.string,
    /**
     * Add more classnames
     */
    type: prop_types_1.default.oneOf(['default', 'grid']),
    /**
     * The HTML inside of the List
     */
    children: prop_types_1.default.node.isRequired,
};
List.defaultProps = {
    className: '',
    type: 'default',
};
